export const FEATURE_FLAG_KEYS = {
  ASSISTANT: "assistant",
  ASSISTANT_HISTORY: "assistant-history",
  ASSISTANT_INSIGHTS: "assistant-insights",
  PROJECT_DRAFTS: "project-drafts",
  DOCUMENT_ASSISTANCE: "document-assistance",
  ASSISTANT_PRODUCERS: "assistant-producers",
  ASSISTANT_PROJECTS: "assistant-projects",
  ASSISTANT_FINANCE: "assistant-finance",
  ASSISTANT_CRM: "assistant-crm",
  ASSISTANT_CONTENT: "assistant-content",
  ASSISTANT_WRITE_ACTIONS: "assistant-write-actions",
  INVESTMENT_CREATE_FLOW: "investment-create-flow",
  INFOSIMPLES: "infosimples",
  PROJECT_PENDENCIES: "project-pendencies",
  PROJECT_DOCUMENT_PRIVATE_UPLOAD: "project-document-private-upload",
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[keyof typeof FEATURE_FLAG_KEYS];

export const KNOWN_FEATURE_FLAG_DEFINITIONS: Array<{
  key: FeatureFlagKey;
  title: string;
  description: string;
  defaultEnabled: boolean;
}> = [
  {
    key: FEATURE_FLAG_KEYS.ASSISTANT_HISTORY,
    title: "Assistente · Histórico privado",
    description: "Conversas privadas com retenção de 30 dias.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.ASSISTANT_INSIGHTS,
    title: "Assistente · Alertas operacionais",
    description: "Alertas factuais do dashboard, sem chamadas de IA.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.PROJECT_DRAFTS,
    title: "Assistente · Rascunhos do projeto",
    description: "Rascunhos extrativos de aspectos técnicos, com revisão e aplicação manual.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.DOCUMENT_ASSISTANCE,
    title: "Assistente · Documentos",
    description: "Respostas com fontes dos documentos privados selecionados.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.ASSISTANT,
    title: "Assistente",
    description: "Habilita o assistente de IA no app.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.ASSISTANT_PRODUCERS,
    title: "Assistente · Produtores",
    description: "Ferramentas do assistente relacionadas a produtores.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.ASSISTANT_PROJECTS,
    title: "Assistente · Projetos",
    description: "Ferramentas do assistente relacionadas a projetos.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.ASSISTANT_FINANCE,
    title: "Assistente · Financeiro",
    description: "Ferramentas do assistente relacionadas ao financeiro.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.ASSISTANT_CRM,
    title: "Assistente · CRM",
    description: "Ferramentas do assistente relacionadas ao CRM.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.ASSISTANT_CONTENT,
    title: "Assistente · Conteúdo",
    description: "Ferramentas do assistente para conteúdo e leitura.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.ASSISTANT_WRITE_ACTIONS,
    title: "Assistente · Ações de escrita",
    description: "Permite ações mutáveis pelo assistente.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.INVESTMENT_CREATE_FLOW,
    title: "Fluxo de criação de investimento",
    description: "Controla o rollout do fluxo de criação de projetos de investimento.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.INFOSIMPLES,
    title: "Consultas InfoSimples",
    description: "Controla o rollout das consultas pagas da InfoSimples.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.PROJECT_PENDENCIES,
    title: "Pendências de projetos",
    description: "Lista as pendências de conclusão dos projetos abertos.",
    defaultEnabled: false,
  },
  {
    key: FEATURE_FLAG_KEYS.PROJECT_DOCUMENT_PRIVATE_UPLOAD,
    title: "Documentos privados do projeto",
    description: "Envio e download autenticado de PDF e TXT vinculados ao projeto.",
    defaultEnabled: false,
  },
];
